import React, { useEffect, useState } from "react";
import RequestHandler from "util/RequestHandler";

import { Table, Empty, Col, Row } from "antd";

const NetsisErpFirmInvoiceReportDetail = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: false,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });

  useEffect(() => getTableData(), [props.documentNumber]);

  const getTableData = () => {
    if (!props.documentNumber) {
      return;
    }

    setTableData({
      ...tableData,
      loading: true,
    });

    RequestHandler.get(
      `/ErpReport/NetsisFirmInvoiceReportDetail/${props.documentNumber}`
    ).then((response) => {
      setTableData({
        data: response,
        total: response.length,
        loading: false,
      });
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const columns = [
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
    },
    {
      title: "Stok Adı",
      dataIndex: "stockName",
    },
    {
      title: "Depo Kodu",
      dataIndex: "warehouseCode",
    },
    {
      title: "Miktar",
      dataIndex: "quantity",
    },
  ];

  return (
    <>
      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey={(row) => row.documentNumber + row.stockCode}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              current: tableDataQueryOptions.current,
              total: tableData.total,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default NetsisErpFirmInvoiceReportDetail;
